import {
  DocumentFragment,
  DocumentType,
} from "../../../../../../__generated__/graphql";
import { communicationTypeToName } from "../../../../../../lib/utils";

export default function DocumentProperties({
  document,
}: {
  document: DocumentFragment;
}) {
  if (document.type !== DocumentType.Communication) {
    return null;
  }

  if (!document.properties) {
    return null;
  }

  const type = document.properties?.type;
  const legend = document.properties?.legend;

  return (
    <div className="flex flex-col gap-2 border border-accent rounded-md p-4">
      {type ? (
        <div className="flex flex-col gap-2">
          <div className="text-sm text-primary font-bold">
            Type de communication
          </div>
          <div className="text-sm text-primary">
            {communicationTypeToName(type)}
          </div>
        </div>
      ) : null}
      {legend ? (
        <div className="flex flex-col gap-2">
          <div className="text-sm text-primary font-bold">
            Légende (à renseigner sous la publication)
          </div>
          <div className="text-sm text-primary">{legend}</div>
        </div>
      ) : null}
    </div>
  );
}
